export class AppSettings
{
  public static cdnUrl = "";
  public static loadingCircleImageURL = AppSettings.cdnUrl+"assets/images/loading-circle-yel.gif";
  public static publicSiteURL = "https://e-gmat.com";

  public static pspURL = "https://gmatplanner.e-gmat.com/psp";
  public static gfePSPUrl = 'https://gmatplanner.e-gmat.com/gfe-psp/';
  public static restApiUrl = 'https://blitzkrieg.e-gmat.com';
  public static stripePublicKey = 'pk_live_j5TgMTokC1wwDkksJv5vksyl';  
  public static riseactivity = 'https://cdn.e-gmat.com/public/rise/getting_started/content/index.html';
  public static scholaraniumURL = 'https://scholaranium2.e-gmat.com';
  public static scholaraniumUiURL = "https://scholaranium2.e-gmat.com/schol-20";

  public static rudderWriteKey = "3IqiFtl41OAwY2q2y0OFAifcmSQ";
  public static rudderDataPlaneUrl = "https://rudderstack.prismlearning.academy";

}
